// ©2024 Austin App House. All rights reserved.
import React from 'react';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { MDBIcon, MDBBtn } from 'mdbreact';
import Notification from '../../notification';

const ContractorExportWorkOrderButton = ({ id }) => (
  <button type="button" className='block_type' onClick={() => exportBankInfoContractors(id)}>
      Download WO
  </button>
);
export default ContractorExportWorkOrderButton;

const exportBankInfoContractors = async (id) => {
  await axios.get(`/api/contractor/exportWorkOrder/${id}`, {
    responseType: 'blob',
  }).then((res) => {
    fileDownload(res.data, 'workOrderDetails.pdf');
  }).catch((error) => {
    Notification('error', {
      message: error.response?.data?.message || error.message,
    });
  });
};
